'use client'

import { FONT_SIZE, FontSize } from '@/app/constants'
import classNames from 'classnames'
import { FC, PropsWithChildren } from 'react'

export interface Props extends PropsWithChildren {
	id?: string
	className?: string
	bgColor?: string
	bgHoverColor?: string
	textColor?: string
	fontSize?: FontSize
	borderColor?: string
	border?: boolean
	rounded?: boolean
	big?: boolean
	bold?: boolean
	disabled?: boolean
	name: string
	type?: 'button' | 'submit'
	font?: 'thin' | 'normal' | 'semibold' | 'bold'
	onClick?: () => void
	'data-testid'?: string
}

const Button: FC<Props> = ({
	id,
	className = '',
	rounded = true,
	bgColor = 'transparent',
	textColor = 'black',
	fontSize = FONT_SIZE.SM,
	border,
	name,
	borderColor,
	big = false,
	bold = false,
	disabled = false,
	onClick,
	children,
	type = 'button',
	font,
	'data-testid': testId,
}) => (
	<button
		id={id}
		data-test-id={id}
		data-testid={testId}
		aria-label={name}
		type={type}
		name={name}
		className={classNames(
			`bg-${bgColor} text-${textColor} text-${fontSize}`,
			'transition-all button',
			{
				'rounded-md': rounded,
			},
			{
				'h-14': big,
			},
			{
				'font-bold': bold && !font,
			},
			{
				[` font-${font}`]: font,
			},
			{
				border,
				[`border-${borderColor}`]: borderColor,
			},
			{
				'opacity-80 pointer-events-none': disabled,
			},
			className
		)}
		onClick={onClick}
	>
		{children}
	</button>
)

export default Button
